import { container } from "assets/jss/material-kit-react.js";

const componentsStyle = {
  container,
  brand: {
    color: "#FFFFFF",
    textAlign: "left",
    marginRight: "15rem",
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "600",
    display: "inline-block",
    marginTop: "1rem",
    // position: "relative",
    color: "white",
    backgroundColor: "rgb(218 28 28 / 50%)",
    marginRight: "15rem",
    padding: "10px 15px",
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "100px",
    margin: "10px 0 0",
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  },
  link: {
    textDecoration: "none",
  },
  textCenter: {
    textAlign: "center",
  },
};

export default componentsStyle;
